import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import classNames from 'classnames'
import { Carousel } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

import { LntIconButton } from '@app/components/base'
import { Show } from '@app/components/util'

import { SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { ForwardRefRenderFunction } from 'react'
import type { LntButtonProps } from '@app/components/base/Button/types'
import type { LntCarouselProps, LntCarouselRef } from './types'

const commonButtonProps: LntButtonProps = {
  size: SIZE.small,
  shape: 'circle',
  type: 'text'
}

const Component: ForwardRefRenderFunction<LntCarouselRef, LntCarouselProps> = (props, ref) => {
  const innerRef = useRef<LntCarouselRef>(null)

  const { children, showEdgeButtons, ...restProps } = props

  const leftButtonClassName: string = classNames(styles.lntCarousel__button, styles.lntCarousel__button_left)
  const rightButtonClassName: string = classNames(styles.lntCarousel__button, styles.lntCarousel__button_right)

  const handleLeft = (): void => innerRef.current?.prev()

  const handleRight = (): void => innerRef.current?.next()

  useImperativeHandle(ref, () => innerRef.current as LntCarouselRef)

  return (
    <div className={ styles.lntCarousel }>
      <Show condition={ showEdgeButtons }>
        <LntIconButton
          { ...commonButtonProps }
          className={ leftButtonClassName }
          icon={ <LeftOutlined /> }
          onClick={ handleLeft }
        />
      </Show>

      <Carousel
        ref={ innerRef }
        { ...restProps }
      >
        { children }
      </Carousel>

      <Show condition={ showEdgeButtons }>
        <LntIconButton
          { ...commonButtonProps }
          className={ rightButtonClassName }
          icon={ <RightOutlined /> }
          onClick={ handleRight }
        />
      </Show>
    </div>
  )
}

export const LntCarousel = forwardRef<LntCarouselRef, LntCarouselProps>(Component)
